/**
 * Dashboard view metadata — keep id/label in sync with server/data/dashboardViews.js
 */
export const dashboardViewOptions = [
  {
    id: "DM",
    label: "Management View",
    description:
      "Company-wide stats, GI Overdue, TR filters",
    descriptionKey: "Management View description",
  },
  {
    id: "DC",
    label: "Consultant View",
    description:
      "Personal order stats and GI outstanding for the logged-in consultant",
    descriptionKey: "Consultant View description",
  },
  {
    id: "DO",
    label: "Operation View",
    description:
      "Same layout as Management View (operations)",
    descriptionKey: "Operation View description",
  },
];
